module.exports = __webpack_public_path__ + "img/consultoria_3-4_2304.5d3d502a.webp";